import React, { useEffect, useRef, useState } from "react"
import ArrowButtons from "../../components/ArrowButtons"
import Slider from "react-slick"
import { Badge } from "flowbite-react"
import { formattedNumber } from "../../utils"
import { navigate } from "gatsby"

const CommonProjects = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [slideToShow, setSlideToShow] = useState(0)
  const sliderRef = useRef(null)

  const handleNavigate = link => {
    navigate(link)
  }
  useEffect(() => {
    const slider = sliderRef.current
    if (slider) {
      const { currentSlide, slidesToShow } = slider.innerSlider.track.props
      setCurrentIndex(currentSlide)
      setSlideToShow(slidesToShow)
    }
  }, [])

  const settings = {
    dots: false,
    infinite: false,
    initialSlide: 0,
    arrows: false,
    speed: 500,
    vertical: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: current => {
      const { slidesToShow } = sliderRef.current.innerSlider.track.props
      setSlideToShow(slidesToShow)
      setCurrentIndex(current)
    },
  }

  const nextSlide = () => {
    sliderRef.current.slickNext()
  }

  const prevSlide = () => {
    sliderRef.current.slickPrev()
  }
  return (
    <section
      id="case-example"
      className=" bg-white-200 grid lg:grid-cols-2 items-center  grid-cols-1 py-12 md:py-[6.75rem]"
    >
      <div
        className={`flex justify-end z-[2] px-6 md:px-20 flex-col-reverse md:flex-col  gap-6 items-start `}
      >
        <div className="lg:flex hidden mb-2 items-center   gap-4">
          <ArrowButtons
            nextDisabled={currentIndex >= data.length - slideToShow}
            prevDisabled={currentIndex === 0}
            nextClick={nextSlide}
            prevClick={prevSlide}
          />
        </div>
        <div className="flex flex-col gap-6 w-full">
          <div className="flex items-center gap-2">
            <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
            <div className="flex gap-3 tracking-tight-4% ">
              <h4 className={`text-gray-500  text-lg lg:text-2xl `}>
                Success Stories
              </h4>
              <Badge
                color="custom-theme"
                className="bg-primary-100 font-normal text-blue-100 py-1 px-3 text-sm rounded-full"
              >
                B2C
              </Badge>
            </div>
          </div>
          <h2
            className={`text-gray-100 text-[3.7rem] md:text-7xl  lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7% `}
          >
            {data[currentIndex].label}
          </h2>
          <div className="flex justify-start gap-12 md:gap-8 lg:gap-16 lg:max-w-[70%]">
            {data[currentIndex].stats.map(stat => (
              <div className="flex flex-col gap-2 md:gap-4" key={stat.heading}>
                {typeof stat.heading === "number" ? (
                  <h3 className="flex font-oxygen items-center text-blue-100  md:-tracking-[4.2px] -tracking-[2.24px] text-[2.5rem] md:text-6xl">
                    {formattedNumber(stat.heading)}

                    <div className=" ">+</div>
                  </h3>
                ) : (
                  <p className=" text-blue-100  md:-tracking-[4.2px] -tracking-[2.24px] text-[2.5rem] md:text-6xl">
                    {stat.heading}
                  </p>
                )}
                <p className="-tracking-[0.32px] text-black-300">
                  {stat.subheading}
                </p>
              </div>
            ))}
          </div>

          <p
            className={`md:text-[1.125rem] hidden lg:block  text-black-300  text-[1rem] md:max-w-[70%] `}
          >
            {data[currentIndex].description}
          </p>
          {!!data[currentIndex].tags.length && (
            <div className="overflow-x-scroll lg:flex hidden  custom-scrollbar md:overflow-x-visible w-full md:w-auto pb-3 md:pb-0 md:max-w-[70%] md:flex-wrap gap-2 md:mt-4 mt-2 items-center">
              {data[currentIndex].tags.map((item, index) => (
                <div
                  key={index}
                  className={`px-3 text-gray-500 border-gray-500 py-1 text-nowrap tracking-tight border rounded-full text-[0.875rem] `}
                >
                  {item}
                </div>
              ))}
            </div>
          )}
          <div className=" flex justify-between items-center mt-2 md:mt-4">
            <button
              onClick={() => handleNavigate(data[currentIndex].link)}
              style={{
                visibility: data[currentIndex].hasNoDetailPage
                  ? "hidden"
                  : "visible",
              }}
              className="border transition-all border-blue-100 hover:border-none hover:bg-blue-100 text-blue-100 hover:text-white-200  rounded-full text-xl tracking-tight-2%  font-normal py-2 md:py-4 px-12 md:px-16 h-14 md:h-16 "
            >
              Read More
            </button>
            <div className="md:hidden block ">
              <ArrowButtons
                nextDisabled={currentIndex === data.length - slideToShow}
                prevDisabled={currentIndex === 0}
                nextClick={nextSlide}
                prevClick={prevSlide}
              />
            </div>
          </div>
        </div>
      </div>
      <div className=" justify-center  my-16 md:my-0 flex flex-col items-center">
        <div className="w-full h-full relative">
          <Slider className="h-full" ref={sliderRef} {...settings}>
            {data.map((item, index) => (
              <div
                key={index}
                className="lg:w-[18rem] bg-white-200 relative w-[23rem] h-[23rem] md:h-[35rem] lg:h-full  grid place-content-center  rounded-full md:mt-16 lg:mt-0"
              >
                <img
                  src={item.image}
                  alt={item.label}
                  className="object-center mx-auto"
                  loading="lazy"
                />{" "}
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className="px-[2rem] md:mt-8  flex flex-col lg:hidden  items-start gap-6">
        <p
          className={`md:text-[1.125rem] text-black-300 text-left min-h-[3rem] text-[1.22rem] md:max-w-[70%]`}
        >
          {data[currentIndex].description}
        </p>
        <div className="flex md:max-w-[70%]  flex-wrap gap-2 mb-2  items-center">
          {data[currentIndex].tags.map((item, index) => (
            <div
              key={index}
              className={`px-2 text-secondary-100 border-gray-300 py-1 border rounded-full text-[0.875rem]`}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CommonProjects
